export type RightsRW = 0 | 1 | 2

export interface StaffRights {
    rw_params_daycare: RightsRW

    rw_staffs: RightsRW
    rw_staff_work: RightsRW

    rw_families: RightsRW
    rw_child: RightsRW
    rw_occasional_slot: RightsRW
    rw_request_slot: RightsRW
    rw_regular_slot: RightsRW

    rw_news: RightsRW
    rw_event_days: RightsRW
    rw_closing_days: RightsRW
    w_add_posts: boolean

    rw_suggestions: RightsRW
    rw_task_note: RightsRW
    rw_meal: RightsRW
}

export interface Permissions {
    write: boolean
    read: boolean
}

export interface StaffPermissions {
    daycareSettings: Permissions
    staffList: Permissions
    staffCalendar: Permissions
    parentList: Permissions
    occasionalSlots: Permissions
    regularSlots: Permissions
    news: Permissions
    addNewsWithoutValidation: { write: boolean }
    suggestions: Permissions
    taskNote: Permissions
    meal: Permissions
}

export const DEFAULT_PERMISSIONS: StaffPermissions = {
    daycareSettings: { read: false, write: false },
    staffList: { read: false, write: false },
    staffCalendar: { read: false, write: false },
    parentList: { read: false, write: false },
    occasionalSlots: { read: false, write: false },
    regularSlots: { read: false, write: false },
    news: { read: false, write: false },
    addNewsWithoutValidation: { write: false },
    suggestions: { read: false, write: false },
    taskNote: { read: false, write: false },
    meal: { read: false, write: false }
}

export interface StaffPermissionsState {
    permissions: StaffPermissions
    staffLevel: string
}
